export default "__VITE_ASSET__BIQ2BRTr__"